'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcBoldClose,
  IconButton,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  Typography,
} from '@musinsa/mds';
import { usePreventBodyScroll } from '../../common/hooks';

export interface CurationRegisterTypeBottomSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectGoods: () => void;
  onSelectSnap: () => void;
}

export function CurationRegisterTypeBottomSheet({
  open,
  onOpenChange,
  onSelectGoods,
  onSelectSnap,
}: CurationRegisterTypeBottomSheetProps) {
  usePreventBodyScroll({ open });

  const close = () => {
    onOpenChange(false);
  };

  return (
    <Sheet direction="bottom" open={open} onOpenChange={onOpenChange}>
      <SheetPortal>
        <SheetContent onPointerDownOutside={close} width="fullWidth">
          <SheetMotion direction="bottom">
            <BottomSheetTitle>
              <BottomSheetHandleArea />
              <BottomSheetTitleContainer className="px-4 py-[9px]">
                <BottomSheetTitleBox>
                  <Typography variant="title16pxMed">큐레이션 등록</Typography>
                </BottomSheetTitleBox>
                <IconButton aria-label="닫기" size="size28x28" onClick={close}>
                  <IcBoldClose />
                </IconButton>
              </BottomSheetTitleContainer>
            </BottomSheetTitle>
            <div className="flex flex-col bg-white safe-area-bottom">
              <button
                type="button"
                className="w-full cursor-pointer px-4 py-3 text-left"
                onClick={() => {
                  onSelectGoods();
                  close();
                }}
              >
                <Typography colorScheme="gray-600" variant="body13pxReg">
                  상품
                </Typography>
              </button>
              <button
                type="button"
                className="w-full cursor-pointer px-4 py-3 text-left"
                onClick={() => {
                  onSelectSnap();
                  close();
                }}
              >
                <Typography colorScheme="gray-600" variant="body13pxReg">
                  스냅
                </Typography>
              </button>
            </div>
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
}
